var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ManagementClientDetail',{attrs:{"client":_vm.client,"export-url":_vm.exportUrl,"breadcrumbs":_vm.breadcrumbs},on:{"detail-program":function($event){return _vm.$router.push({
      name: 'admin.clients-programs',
      params: { programId: $event },
    })}}})}
var staticRenderFns = []

export { render, staticRenderFns }